export default {
  teams: {
    loading: false,
    lastUpdate: null,
    data: [],
  },

  roas: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  familyGroup: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  officeParametrization: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  benchmarks: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  rubrics: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  departments: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  permissionsAssessor: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  routesSettings: {
    bi: {
      standard: {
        title: 'BI - INTELIGÊNCIA DE NEGÓCIO',
        icon: 'graph-pie',
        color: '#8E8E8E',
        name: 'settings-v2.bi.home',
      },

      pathRoutes: [],
    },
    comissoes: {
      standard: {
        title: 'Comissões',
        icon: 'coin',
        color: '#286A62',
        name: 'settings-v2.comissoes.home',
      },
      pathRoutes: [],
    },
    finance: {
      standard: {
        title: 'FINANCEIRO',
        icon: 'graph-pie',
        color: '#3F5D59',
        name: 'settings-v2.finance.home',
      },
      pathRoutes: [],
    },
    estrategia: {
      standard: {
        title: 'ESTRATÉGIA E PERFORMANCE',
        icon: 'chart-bar-new-ux',
        color: '#BDA767',
        name: 'settings-v2.estrategia.home',
      },
      pathRoutes: [],
    },
    crm: {
      standard: {
        title: 'CRM',
        icon: 'task',
        color: '#4250AF',
        name: 'settings-v2.crm.home',
      },
      pathRoutes: [],
    },
    atendimento: {
      standard: {
        title: 'MENSAGENS',
        icon: 'mdi-whatsapp',
        color: '#25D366',
        name: 'settings-v2.atendimento.home',
      },
      pathRoutes: [],
    },
    general: {
      standard: {
        title: 'CONFIGURAÇÕES GERAIS',
        icon: '',
        color: '',
        name: 'settings-v2.general.home',
      },
      pathRoutes: [],
    },
    asset_allocation: {
      standard: {
        title: 'CONSOLIDADOR - ASSET ALLOCATION',
        icon: 'donut',
        color: '#AF9692',
        name: 'settings-v2.asset_allocation.home',
      },
      pathRoutes: [],
    },
    rh: {
      standard: {
        title: 'GESTÃO DE DESEMPENHO',
        icon: 'users',
        color: '#C585C3',
        name: 'settings-v2.rh.home',
      },
      pathRoutes: [],
    },
    financial_planning: {
      standard: {
        title: 'FINANCIAL PLANNING',
        icon: 'graph-pie',
        color: '#3B7356',
        name: 'settings-v2.financial-planning',
      },
      pathRoutes: [],
    },
    compliance: {
      standard: {
        title: 'COMPLIANCE',
        icon: 'book-cover',
        color: '#245ca6',
        name: 'settings-v2.compliance.home',
      },
      pathRoutes: [],
    },
    juridico: {
      standard: {
        title: 'Partnership',
        icon: 'receipt-items',
        color: '#E0904A',
        name: 'settings-v2.juridico.home',
      },
      pathRoutes: [],
    },
  },
  repositoryFiles: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  assetAllocationTypes: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  dreTempFilters: {
    data: {},
  },
  superRankingClusters: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  superRankingCycles: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  superRankingIndicators: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  superRankingFunctions: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  openFinanceConexoes: {
    index: [],
    data: [],
  },
  // {{NEXT}}
}
